import moment from "moment";
import { any, func } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";
import history from "../../history";
import { postRoyalMailForm } from "../../redux/actions/royalMailActions";
import * as style from "./styles.module.scss";

const InductionConfirmation = ({ appData, postRoyalMailFormFunc }) => {
  const { firstName = "", lastName = "" } = appData;

  let initialData = {
    fullName: `${firstName} ${lastName}`,
    signature: `${firstName} ${lastName}`,
    date: moment().format("DD/MM/YYYY"),
  };

  if (
    appData.royalMailOnboarding &&
    appData.royalMailOnboarding.inductionForm
  ) {
    initialData = {
      ...initialData,
      ...appData.royalMailOnboarding.inductionForm,
    };
  }

  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";
  const getVal = getField(initialData);

  const initialState = {
    delimiter: {
      htmlObj: (
        <HorizontalLine
          desc={"Answer the questions below and sign this declaration."}
        />
      ),
    },
    feedback: {
      htmlObj: (
        <div className={style.inductionform__subtext}>
          <h5>Feedback</h5>
          <p className="mb-0">
            We welcome any comments that you may have about your assignment with
            Royal Mail.
          </p>
          <p>
            You can contact your agency for an informal chat with your
            recruitment consultant to provide feedback.
          </p>
        </div>
      ),
    },
    firstPoint: {
      title:
        "1. State one of the Royal Mail values which you think will be important in the job you will do.",
      type: "textarea",
      value: getVal("firstPoint"),
      mandatory: true,
    },
    secondPoint: {
      title:
        "2. Who should you report any crime or suspected crime against Royal Mail Group to?",
      type: "textarea",
      value: getVal("secondPoint"),
      mandatory: true,
    },
    thirdPoint: {
      title:
        "3. What should you do if you think you have been treated unfairly or without respect?",
      type: "textarea",
      value: getVal("thirdPoint"),
      mandatory: true,
    },
    fourthPoint: {
      title: "4. State one cause of lost letters or parcels.",
      type: "textarea",
      value: getVal("fourthPoint"),
      mandatory: true,
    },
    fifthPoint: {
      title: "5. State one tip for safe handling and lifting.",
      type: "textarea",
      value: getVal("fifthPoint"),
      mandatory: true,
    },
    fullName: {
      title: "I (full name):",
      mandatory: true,
      value: getVal("fullName"),
    },
    del: {
      htmlObj: (
        <div>
          <div className="mb-hf">
            have read and understood this booklet and am fully aware of the
            content and my obligations regarding personal safety and my duty to
            safeguard the mail.
          </div>
          <div>
            If completed online, please type/print your name below. The return
            of this document replaces the requirement for your handwritten
            signature.
          </div>
        </div>
      ),
    },
    signature: {
      title: "Signature:",
      value: getVal("signature"),
      mandatory: true,
    },
    date: {
      title: "Date:",
      value: getVal("date"),
      mandatory: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const handleSubmit = () => {
    postRoyalMailFormFunc("inductionForm", formCreatorConvertToValues(fields));
    history.push("/profile/edit/royal-mail-onboarding");
  };
  return (
    <FormCreator
      formTitle={"Confirmation of Induction"}
      description={
        "Before starting work at a Royal Mail site, you will need to have read through and understood the booklet provided to you. Any questions you have should be directed to your HRGO Consultant."
      }
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
    />
  );
};

InductionConfirmation.propTypes = {
  appData: any,
  postRoyalMailFormFunc: func.isRequired,
};
const mapDispatchToProps = {
  postRoyalMailFormFunc: postRoyalMailForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(InductionConfirmation);
